import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { adminBrightPatternTemplateApi } from '../../api/adminBrightPatternTemplate.api';
import { apiHandler, unwrapData } from '../../utils/apiHandler';
import '../subscription-plans/subscription-plans.css';
import './bright-pattern-templates.css';

export default function BrightPatternTemplateList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    const result = await apiHandler(() => adminBrightPatternTemplateApi.list());
    if (result.success) {
      setRows(unwrapData(result) || []);
    } else {
      setError(result.message || 'Failed to load Bright Pattern templates');
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const handleDeactivate = async (row) => {
    if (!window.confirm(`Deactivate "${row.name}"?`)) return;
    const result = await apiHandler(() => adminBrightPatternTemplateApi.deactivate(row.id));
    if (result.success) {
      setMessage(result.message || `Deactivated ${row.name}`);
      load();
    } else {
      setError(result.message || 'Failed to deactivate template');
    }
  };

  return (
    <div className="sp-page bpt-page">
      <PageHeader
        title="Bright Pattern Templates"
        subtitle="Contact center dashboard types sent to Bright Pattern (name + slug only for now)"
        actions={(
          <button type="button" className="sp-btn sp-btn-primary" onClick={() => navigate('/bright-pattern-templates/new/edit')}>
            <i className="fa-solid fa-plus" /> Create template
          </button>
        )}
      />

      {error && <div className="sp-alert sp-alert-danger">{error}</div>}
      {message && <div className="sp-alert sp-alert-success">{message}</div>}

      {loading && (
        <div className="sp-loading">
          <i className="fa-solid fa-spinner fa-spin" /> Loading templates…
        </div>
      )}

      {!loading && rows.length === 0 && (
        <div className="sp-empty">
          <div><i className="fa-solid fa-headset" /></div>
          <p>No Bright Pattern templates yet.</p>
        </div>
      )}

      {!loading && rows.length > 0 && (
        <div className="bpt-table-wrap">
          <table className="bpt-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td><span className="bpt-slug">{row.slug}</span></td>
                  <td>
                    <span className={`sp-badge ${row.isActive ? 'sp-badge-active' : 'sp-badge-inactive'}`}>
                      {row.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="bpt-actions">
                      <button
                        type="button"
                        className="sp-btn sp-btn-secondary sp-btn-sm"
                        onClick={() => navigate(`/bright-pattern-templates/${row.id}/edit`)}
                      >
                        Edit
                      </button>
                      {row.isActive && (
                        <button
                          type="button"
                          className="sp-btn sp-btn-secondary sp-btn-sm"
                          onClick={() => handleDeactivate(row)}
                        >
                          Deactivate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
